import * as core from '../../../../../../../core'
import * as orgJointUseCalcMode from '../org-joint-use-calculation-mode'

export const RESOURCE = {
  payload: {
    description: 'Inherit',
    enumId: core.dms.models.Enum.Id.from({
      partialId: orgJointUseCalcMode.RESOURCE.payload.partialId,
    }),
    id: 'INHERIT',
    name: 'Inherit',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
